<p-dialog [modal]="true"
          [(visible)]="layoutService.showProgressDialog"
          [style]="{width: widthValue}"
          [header]="title"
          [closable]="false"
          [resizable]="false"
          [draggable]="false">
  @if (showProgressSpinner) {
    <div class="flex w-full justify-content-center">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    </div>
  } @else {
    <p-progress-bar [value]="layoutService.progressValue()"></p-progress-bar>
  }
</p-dialog>
